export default __webpack_public_path__ + "static/media/header-syndi.84a74a4a.png";